import { render, staticRenderFns } from "./modal_add_news_trend.vue?vue&type=template&id=0ebb1bf6&scoped=true&"
import script from "./modal_add_news_trend.vue?vue&type=script&lang=js&"
export * from "./modal_add_news_trend.vue?vue&type=script&lang=js&"
import style0 from "./modal_add_news_trend.vue?vue&type=style&index=0&id=0ebb1bf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebb1bf6",
  null
  
)

export default component.exports